import { useNavigate } from "react-router-dom";
import SVGComponent from "../SVGComponent";
import ICONS from "../../../assets/Icons";
import TEXT from "../../../utils/globalText";
import PrimaryButton from "../CommonButtons/PrimaryButton";
const CommonReminderPopupCard = ({
  reminderId,
  reminderRemark,
  reminderDate,
  reminderAmount,
  hasCreateInternalService,
  hasCreateService,
  setShowModal,
  setSelectedTxnData,
  buttonText,
  primaryBtnBgColor,
}) => {
  const navigate = useNavigate();
  return (
    <div className="rounded-border-radius-sm bg-primary-card px-padding-md py-padding-sm ">
      <div className="flex flex-col gap-gap-md overflow-x-hidden">
        <div className="flex flex-col gap-1 items-start">
          <p className="text-text-primary font-semibold text-font-sm">
            Reminder {reminderId}
          </p>
          <p className="text-font-xs text-text-secondary">
            {reminderRemark?.charAt(0).toUpperCase() + reminderRemark?.slice(1)}
          </p>
        </div>
        {/* date and button */}
        <div className="flex flex-row items-center  justify-between gap-2">
          <div className="flex flex-row gap-gap-sm items-center">
            <SVGComponent
              url={ICONS.CALENDER}
              height="var(--icon-sm)"
              width="var(--icon-sm)"
              color={"var(--text-primary)"}
            />
            <p className="text-text-primary font-semibold text-font-xs">
              {reminderDate}
            </p>
          </div>
          <PrimaryButton
            btnText={buttonText}
            handleFunction={(e) => {
              if (hasCreateService || hasCreateInternalService) {
                setSelectedTxnData({
                  reminderRemark: reminderRemark,
                  reminderAmount: reminderAmount || "",
                });
                setShowModal(true);
              } else {
                e.stopPropagation();
                navigate("/feature_not_assigned", {
                  state: {
                    unavailableService: "CBeneficiaryTxn,CInternalTxn",
                  },
                });
              }
            }}
            isDisabled={!(hasCreateService || hasCreateInternalService)}
            enabledBgColor={primaryBtnBgColor}
            enabledTextColor="var(--text-primary)"
            hoverOption="white"
          />
        </div>
      </div>
    </div>
  );
};
export default CommonReminderPopupCard;
